import React from 'react';

function ExpandIcon() {
  return (
    <svg id="expand-icon" width="16" height="9" viewBox="0 0 16 9" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.67729 8.73574C8.28499 9.09739 7.67363 9.08784 7.29289 8.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8 6.58579L14.2929 0.292893C14.6834 -0.0976311 15.3166 -0.0976311 15.7071 0.292893C16.0976 0.683418 16.0976 1.31658 15.7071 1.70711L8.70711 8.70711C8.69718 8.71703 8.68724 8.72656 8.67727 8.73572L8.67729 8.73574Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
      />
    </svg>
  );
}

export default ExpandIcon;
